module.exports = __webpack_public_path__ + "homeStatic/img/zuoye.9e2dde6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/personal/zuoye.png
// module id = 9xvD
// module chunks = 1